<template>
  <div class="breadcrumb">
    <template v-for="item in this.crumbs">
        <template v-if="item[0] > 0">
          <router-link
            :to=item[2]
            :key="item[0]"
          >{{item[1]}}</router-link>
          &gt;
        </template>
        <template v-else >
          {{item[1]}}
        </template>
    </template>
  </div>
</template>

<script>
export default {
  name: 'breadcrumb',
  props: ['location', 'siteNames', 'gwNames'],

  methods: {
    siteName(siteId) {
      if (siteId in this.siteNames) {
        return this.siteNames[siteId]['name']
      }
      return `Site ${siteId}`
    },

    gwName(gwSerial) {
      if (gwSerial in this.gwNames) {
        return this.gwNames[gwSerial]
      }
      return `GW ${gwSerial}`
    },
  },

  computed: {
    crumbs: function() {
      // Location examples (/dashboard/<siteId>/<gwSerial>/<invSerial>)
      // _.siteId_   _.gwSerial_   _listType_  _selectedId_  _breadcrumb_   _link_              _meaning_
      //      -            -         sites           -         All sites     /dashboard          - sites list, first site selected
      //      0            -         sites           -         All Sites     /dashboard/0        - sites list, first site selected
      //     11            -         sites          11         All sites     /dashboard/11       - sites list, site 11 selected
      //     11            0          gws            -         Site 11       /dashboard/11/0     - gws list, first gw selected
      //     11           22          gws           22         Site 11       /dashboard/11/22    - gws list, gw 22 selected
      //     11           22         invs            -         GW 22         /dashboard/11/22/0  - invs list, first inv selected
      //     11           22         invs           33         GW 22         /dashboard/11/22/33 - invs list, inv 33 selected

      let res = [] // list of tuple (key, title, router-link 'to')
      let key = 0 // key counts down to zero so that the last entry has key==0
      if (this.location.listType === this.location.TYPE_GWS) {
        key = 1
      }
      if (this.location.listType === this.location.TYPE_INVS) {
        key = 2
      }

      res.push([
        key,
        'All sites',
        { name: 'dashboard_sites', params: { siteId: 0 } },
      ])
      key--

      if (this.location.listType === this.location.TYPE_GWS || this.location.listType === this.location.TYPE_INVS) {
        res.push([
          key,
          this.siteName(this.location.siteId),
          {
            name: 'dashboard_site-gws',
            params: { siteId: this.location.siteId, gwSerial: 0 },
          },
        ])
        key--
      }

      if (this.location.listType === this.location.TYPE_INVS) {
        res.push([
          key,
          this.gwName(this.location.gwSerial),
          {
            name: 'dashboard_site-gw-invs',
            params: {
              siteId: this.location.siteId,
              gwSerial: this.location.gwSerial,
              invSerial: 0,
            },
          },
        ])
        key--
      }

      // console.log("CRUMB", this.location, res)
      return res
    },
  },
}
</script>

<style lang="scss">
@import "../../vuestic-sass/resources/resources";

.breadcrumb {
  color: $vue-darkest-blue;

  &--caption {
    font-size: $font-size-smaller;
    color: $brand-secondary;
    line-height: 1.3rem;
  }
}
</style>
